import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import { computed, reactive } from "@vue/composition-api";
import * as ApplicationStandAloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import * as ApplicationStandAloneMutations from "@Client/@Modules/application-standalone/store/application-standalone-mutations";
import * as ApplicationStandAloneActions from "@Client/@Modules/application-standalone/store/application-standalone-actions";
import { useApplicationStandaloneStoreActions, useApplicationStandaloneStoreGetters, useApplicationStandaloneStoreMutations } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { EmptyApplication } from "@Shared/@DataFiles/empty-application";
import { forEach, get } from "lodash";
export const useBindApplication = () => {
  const {
    GET_FIELD_BY_PATH
  } = useApplicationStandaloneStoreGetters([ApplicationStandAloneGetters.GET_FIELD_BY_PATH]);
  const {
    DECRYPT_SIN,
    UPDATE_APPLICATION_FIELD
  } = useApplicationStandaloneStoreActions([ApplicationStandAloneActions.DECRYPT_SIN, ApplicationStandAloneActions.UPDATE_APPLICATION_FIELD]);
  const {
    ADD_ARRAY_FIELD_BY_PATH,
    DELETE_ARRAY_FIELD_BY_PATH,
    UNSHIFT_ELEMENT
  } = useApplicationStandaloneStoreMutations([ApplicationStandAloneMutations.ADD_ARRAY_FIELD_BY_PATH, ApplicationStandAloneMutations.DELETE_ARRAY_FIELD_BY_PATH, ApplicationStandAloneMutations.UNSHIFT_ELEMENT]);
  const bindApplication = (path, defaultValue) => {
    return computed({
      get() {
        var _GET_FIELD_BY_PATH$va, _path$value;
        return (_GET_FIELD_BY_PATH$va = GET_FIELD_BY_PATH.value((_path$value = path == null ? void 0 : path.value) != null ? _path$value : path)) != null ? _GET_FIELD_BY_PATH$va : defaultValue;
      },
      set(value) {
        var _path$value2;
        UPDATE_APPLICATION_FIELD({
          path: (_path$value2 = path == null ? void 0 : path.value) != null ? _path$value2 : path,
          value
        });
      }
    });
  };
  const bindAddressField = path => {
    const addressPath = computed(() => {
      var _path$value3;
      return (_path$value3 = path == null ? void 0 : path.value) != null ? _path$value3 : path;
    });
    const addressStructure = computed(() => {
      var _context;
      return get(EmptyApplication(), _replaceAllInstanceProperty(_context = addressPath.value).call(_context, /\[[0-9]+\]/g, "[0]"));
    });
    const bindMap = computed(() => {
      const mapBind = {};
      forEach(addressStructure.value, (value, key) => {
        mapBind[key] = bindApplication(addressPath.value + `[${key}]`, value);
      });
      return mapBind;
    });
    return computed(() => reactive(bindMap.value));
  };
  const commitNestedField = (path, leafKey, value) => {
    const pathToUse = path + (value === undefined ? "" : leafKey);
    const valueToUse = value === undefined ? leafKey : value;
    UPDATE_APPLICATION_FIELD({
      path: pathToUse,
      value: valueToUse
    });
  };
  const addNestedField = (path, value) => {
    ADD_ARRAY_FIELD_BY_PATH({
      path,
      value
    });
  };
  const unshiftNestedField = (path, value) => {
    UNSHIFT_ELEMENT({
      path,
      value
    });
  };
  const removeNestedField = (path, index) => {
    DELETE_ARRAY_FIELD_BY_PATH({
      path,
      index
    });
  };
  const decryptApplicantSin = async (applicantSinPath, applicantIndex) => {
    return DECRYPT_SIN({
      applicantIndex,
      applicantSinPath
    });
  };
  const makeFieldPathReactive = (rootPath, path) => computed(() => rootPath.value + path);
  return {
    bindApplication,
    commitNestedField,
    addNestedField,
    unshiftNestedField,
    removeNestedField,
    bindAddressField,
    decryptApplicantSin,
    makeFieldPathReactive
  };
};